import React, { useEffect, useState } from "react";
import { getWorkOrderList, deleteWorkOrder as deleteWorkOrderApi } from "../../api/workorders";
import LGModalCrud from "../../organisms/LGCrud/LGModalCrud";
import WorkOrderForm from "../../organisms/WorkOrders/WorkOrderForm.tsx";
import DashboardLayout from "../../layouts/DashboardLayout";
import { useCompany } from "../../contexts/CompanyContext";
import { Box, Typography } from "@mui/material";

const columns = [
  {
    field: "id",
    headerName: "Código",
    width: 150,
  },
  {
    field: "finishedGoodName",
    headerName: "Producto Terminado",
    width: 200,
  },
  {
    field: "estimateCompletionDate",
    headerName: "Fecha Estimada",
    width: 150,
  },
  {
    field: "statusName",
    headerName: "Estado",
    width: 130,
  },
];

export default function WorkOrderScreen() {
  const { selectedCompany } = useCompany();
  const [key, setKey] = useState(0);

  useEffect(() => {
    setKey((prevKey) => prevKey + 1);
  }, [selectedCompany]);

  const fetchWorkOrders = async (params) => {
    const response = await getWorkOrderList(params);
    return response;
  };

  const deleteWorkOrder = async (id) => {
    await deleteWorkOrderApi(id);
  };

  if (!selectedCompany) {
    return (
      <DashboardLayout>
        <Box p={4}>
          <Typography>Seleccione una compañía primero</Typography>
        </Box>
      </DashboardLayout>
    );
  }

  const props = {
    fetchFunction: fetchWorkOrders,
    deleteFunction: deleteWorkOrder,
    columns: columns,
    addModalData: {
      header: "Nueva Orden de Trabajo",
      body: <WorkOrderForm companyId={selectedCompany.id} />,
    },
    editModalData: {
      header: "Editar Orden de Trabajo",
      body: <WorkOrderForm companyId={selectedCompany.id} />,
    },
    actions: ["create", "update", "delete"],
  };

  return (
    <DashboardLayout>
      <LGModalCrud key={key} props={props} />
    </DashboardLayout>
  );
}